
interface ContextProps {
	children: JSX.Element | JSX.Element[];
	contextMenuSide: string;
	setIsContextOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ContextMenu(props: ContextProps) {
	const sideStyle = props.contextMenuSide == "left" ? " left-0 " : " right-0 ";

	return (
		<div
			className={
				"absolute top-1 max-w-sm rounded border bg-white p-1 font-normal text-gray-600 shadow " +
				sideStyle
			}
		>
			<ul
				className="w-full "
				style={{ overflow: "hidden", borderRadius: "0.3rem" }}
			>
				{props.children}
			</ul>
		</div>
	);
}
